/**
 * Servicio para actualizar el estado de un pedido
 */
import axiosInstance from '../../api/axiosInstance'

export interface UpdateOrderStatusRequest {
  status: string
  motivo?: string
  solucion?: string
  meta_data?: Array<{
    key: string
    value: string
  }>
}

export interface UpdateOrderStatusResponse {
  success: boolean
  message: string
  data?: any
}

/**
 * Actualizar el estado de un pedido
 */
export async function updateOrderStatus(
  orderId: number,
  data: UpdateOrderStatusRequest
): Promise<UpdateOrderStatusResponse> {
  try {
    const token = localStorage.getItem('accessToken')
    if (!token) {
      throw new Error('No se encontró token de autenticación')
    }

    const updateData: any = {
      status: data.status,
    }

    // Agregar motivo o solución a meta_data
    if (data.motivo || data.solucion) {
      updateData.meta_data = data.meta_data || []
      
      if (data.motivo) {
        updateData.meta_data.push({
          key: 'motivo_incidencia',
          value: data.motivo,
        })
        updateData.meta_data.push({
          key: 'fecha_incidencia',
          value: new Date().toISOString(),
        })
      }
      
      if (data.solucion) {
        updateData.meta_data.push({
          key: 'solucion_incidencia',
          value: data.solucion,
        })
        updateData.meta_data.push({
          key: 'fecha_resolucion',
          value: new Date().toISOString(),
        })
      }
    }

    // Agregar meta_data adicional si existe
    if (data.meta_data && data.meta_data.length > 0) {
      updateData.meta_data = [...(updateData.meta_data || []), ...data.meta_data]
    }

    const response = await axiosInstance.patch<UpdateOrderStatusResponse>(
      `/list/${orderId}`,
      updateData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    return {
      success: true,
      message: response.data?.message || 'Estado actualizado exitosamente',
      data: response.data?.data || response.data,
    }
  } catch (error: any) {
    console.error('Error actualizando estado del pedido:', error)
    throw new Error(
      error.response?.data?.message ||
        `Error al actualizar el estado: ${error.message}`
    )
  }
}

